import {
  CHANGE_SPINE_BACKGROUND_COLOR,
  LOAD_SPINE_DEFAULTS,
  CHANGE_SPINE_COLOR,
  CHANGE_SPINE_TEXT,
  CHANGE_FONT_SIZE,
  CHANGE_FONT_FAMILY,
  LOAD_COVER_DETAILS_BY_BOOK_ID,
} from '../../action-types/entities/cover';


export const STATE_KEY = 'cover';

export const cover = (state = { spine: {} }, action) => {
  switch (action.type) {
    case LOAD_COVER_DETAILS_BY_BOOK_ID: {
      return action.bookstate;
    }

    case LOAD_SPINE_DEFAULTS: {
      const coverDefaults = {
        spine: {
          text: '',
          backgroundColor: '#ffffff',
          color: '',
          fontFamily: 'Courier',
          height: 0,
          fontSize: 24,
          transformations: {
            x: 0,
            y: 0,
            rotate: -90,
          },
        },
      };
      const coverDetails = Object.assign({}, coverDefaults, action.cover);
      return coverDetails;
    }
    case CHANGE_SPINE_BACKGROUND_COLOR: {
      const { backgroundColor } = action;
      return {
        spine: {
          ...state.spine,
          backgroundColor,
        },
      };
    }

    case CHANGE_SPINE_COLOR: {
      const { color } = action;
      return {
        spine: {
          ...state.spine,
          color,
        },
      };
    }

    case CHANGE_SPINE_TEXT: {
      const { text } = action;
      return {
        spine: {
          ...state.spine,
          text,
        },
      };
    }

    case CHANGE_FONT_SIZE: {
      const { fontSize } = action;
      return {
        spine: {
          ...state.spine,
          fontSize,
        },
      };
    }

    case CHANGE_FONT_FAMILY: {
      const { fontFamily } = action;
      return {
        spine: {
          ...state.spine,
          fontFamily,
        },
      };
    }

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/redux/reducers/entities/cover.js